import React, { useState, useEffect } from "react";
import List from "../styledComponents/Table/List";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import moreIcon from "../../assets/images/DeathModuleNew/Menu.png";
import moment from "moment";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import "./subscription.css";
import { PaymentMethods } from "./PaymentMethods";
import { PaymentsNew } from "./PaymentsNew";
export const Subscription = () => {
  const [subscriptionsDetails, setSubscriptionsDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const history = useHistory();
  const [subscription, setSubscription] = useState(null);

  const cols = [
    {
      title: "ID",
      dataIndex: "id",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Subscription Type",
      dataIndex: "subscriptionType",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },
    {
      title: "Amount",
      dataIndex: "amountPaid",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Description",
      dataIndex: "subscriptionDescription",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Cancel Subscription",
      render: (record, index) => {
        return (
          <div key={index}>
            {" "}
            <img
              style={{ cursor: "pointer", marginLeft: "1rem" }}
              src={moreIcon}
              alt="moreIcon"
              onClick={() => {
                console.log("recode", record.id);
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
            ></img>{" "}
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999", width: "14%" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}
                    >
                      Cancel Subscription
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const getSelectedRow = (idx) => {
    console.log("idx>>>", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = subscriptionsDetails.filter((row, index) => {
      return row.id == idx;
    });
    // get first and only element from list and store it in update object
    console.log("selectedRow[0]", selectedRow[0]);
    // setUpdateObject(selectedRow[0]);
  };
  const signOut = (e) => {
    // e.preventDefault();
    localStorage.removeItem("userLoginToken");
    localStorage.removeItem("role");
    localStorage.removeItem("delegateUsers");
    localStorage.removeItem("otp");
    localStorage.removeItem("User");
    localStorage.removeItem("fields");
    localStorage.removeItem("accessId");
    localStorage.removeItem("duplicateRole");
    localStorage.removeItem("profile");
    localStorage.removeItem("permissionState");
    localStorage.removeItem("userName");
    localStorage.clear();
    history.push("/login");
  };
  const deleteSelectedRow = async (idx) => {
    // var that = this;
    let res = null;
    swal({
      title: "Are you sure?",
      text: "You will be logged out and no longer have access to your information.",
      dangerMode: true,
      buttons: ["No!", "Yes!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          res = await DEATH_API.cancelSubscription();
          setLoading(false);
          if (res.status === 200) {
            signOut();
          }
          // getSubscriptionDetails();
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal(
            res.message ===
              "Subscription Cannot Be Canceled During Trail Period."
              ? "Cancelled!"
              : "Cancelled!",
            res.message,
            res.message ===
              "Subscription Cannot Be Canceled During Trail Period."
              ? "error"
              : "success"
          );
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your Subscription is safe :)", "error");
      }
    });
  };
  const getSubscriptionDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getSubscriptionList();
      if (data && data.data) {
        setSubscriptionsDetails(data.data);
        setSubscription(data.data[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    getSubscriptionDetails();
  }, []);
  return (
    <div className="profileMain">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1
          style={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: "600" }}
        >
          Subscription Details
        </h1>
      </div>
      <div style={{ padding: "2rem" }}>
        <div>
          <div className="infocardrow">
            <div className="infocardrowData">
              <span className="infocardTitle1"> Subscription Plan</span>
              <span className="infocardsubTitle">
                {subscription && subscription.subscriptionType}
              </span>
            </div>
            {/*<div className="infocardrowData">
              <span className="infocardTitle1"> Card Last Four Digit </span>
              <span className="infocardsubTitle">
                {" "}
                {subscription && subscription.subscriptionType}
              </span>
  </div> */}
          </div>
          <div className="infocardrow2">
            <div className="infocardrowData">
              <span className="infocardTitle1"> Subscription Status</span>
              <span className="infocardsubTitle">
                {subscription && subscription.subscriptionDescription}
              </span>
            </div>
            <div className="infocardrowData">
              <span className="infocardTitle1"> Started On </span>
              <span className="infocardsubTitle">
                {" "}
                {subscription &&
                  subscription.startDate &&
                  moment(subscription.startDate).format("MM-DD-YYYY")}
              </span>
            </div>
          </div>
          <div className="infocardrow2">
            <div className="infocardrowData">
              <span className="infocardTitle1"> Trial Ended On</span>
              <span className="infocardsubTitle">
                {" "}
                {subscription &&
                  subscription.trailEndDate &&
                  moment(subscription.trailEndDate).format("MM-DD-YYYY")}
              </span>
            </div>
            <div className="infocardrowData">
              <span className="infocardTitle1"> Last Payment </span>
              <span className="infocardsubTitle">
                ${subscription && subscription.amountPaid}
              </span>
            </div>
          </div>
          <div className="infocardrow2">
            <div className="infocardrowData">
              <span className="infocardTitle1"> Total Amount</span>
              <span className="infocardsubTitle">
                ${subscription && subscription.amountPaid}
              </span>
            </div>
            <div className="infocardrowData">
              <span className="infocardTitle1"> Coupon</span>
              <span className="infocardsubTitle">
                {" "}
                {subscription && subscription.coupon}
              </span>
            </div>
          </div>
          <div className="subscriptionButtons">
          <button
            className="savebutton"
            style={{
              textAlign: "center",
              marginTop: "2rem",
              fontSize: "12px",
              fontWeight: "700",
              padding: "12px 40px",
              background: "#DC2C2C",
            }}
            type="submit"
            onClick={() => {
              deleteSelectedRow(subscription && subscription.id);
            }}
          >
            Cancel Subscription
          </button>
          <button
          className="savebutton"
          style={{
            textAlign: "center",
            marginTop: "2rem",
            fontSize: "12px",
            fontWeight: "700",
            padding: "12px 40px",
          }}
          type="submit"
          onClick={() => {
            history.push("/payment");
          }}
        >
          Upgrade Subscription
        </button>
        </div>
        </div>
      </div>
      <PaymentsNew />
      {/*<PaymentMethods /> */}
      {/*<div className="rolesTable" style={{ marginTop: "10px" }}>
        <div className="RolesHeader">
          <div className="RoleTitle">Subscriptions Details</div>
        </div>
        <List cols={cols} rows={subscriptionsDetails} />
        </div>*/}
      <Loader isLoading={loading} />
    </div>
  );
};
